import React from 'react';
import { Route } from 'react-router-dom';
import Upload from './containers/Upload';
import EstimateMain from 'containers/EstimateMain';

export default [
    <Route exact path="/upload" component={Upload} />,
    <Route exact path="/estimator" component={EstimateMain} noLayout />
];